import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-users-gear" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import { watch, reactive, ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { USER } from "@/const/cookie";
import { useCookies } from "vue3-cookies";
import store from "@/store/index";

export default /*#__PURE__*/_defineComponent({
  __name: 'Social',
  setup(__props) {

const { cookies } = useCookies();
const router = useRouter();
const qrCode = () => {
  router.push({ path: "/dashboard" });
};
const show = ref(false);
onMounted(async () => {
    await loadData()
});
const isLoadLogin = computed(() => {
  return store.getters.isLoadLogin;
});
watch(isLoadLogin, async (newValue, oldValue) => {
  await loadData()
});

const loadData = () => {
    let user = cookies.get(USER);
  if (user != null) {
    let roles = user.role;
    if (roles == 9) {
      show.value = true;
    }
  } else {
    show.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_float_button = _resolveComponent("a-float-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_a_float_button_group = _resolveComponent("a-float-button-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_float_button_group, {
      shape: "circle",
      style: {"right":"24px","bottom":"80px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tooltip, {
          placement: "left",
          key: "#108ee9",
          title: "Quản trị website",
          color: "#108ee9"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_a_float_button, {
              class: "bg-icon-right",
              type: "primary"
            }, {
              icon: _withCtx(() => [
                _createElementVNode("a", {
                  style: {"color":"#fff"},
                  onClick: qrCode
                }, _hoisted_2)
              ]),
              _: 1
            }, 512), [
              [_vShow, show.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_back_top, {
          class: "bg-icon-right",
          type: "primary"
        })
      ]),
      _: 1
    })
  ]))
}
}

})